module.exports = __webpack_public_path__ + "img/kingyo_home.678bf2a8.svg";